import { Send, ErrorCircle, CheckCircle } from '@ori-ui/icons';

import { NewsletterTitleIconType } from './types';

export const titleIcons = {
  [NewsletterTitleIconType.Submit]: Send,
  [NewsletterTitleIconType.Subscribe]: CheckCircle,
  [NewsletterTitleIconType.Error]: ErrorCircle,
};
